import React from 'react';
import { testimonials } from '../data/finanza';
export function Testimonials() {
  // Nascosta finché non ci sono recensioni autentiche di FINANZA PRONTA in data/finanza.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-[#1E2B58]/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-282" data-mp="3fycpzlihi3a9">
      <div className="mx-auto max-w-6xl" data-id="element-283" data-mp="3b01hbe3xdytm">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-[#1E2B58] sm:text-6xl" data-id="element-284" data-mp="36yzhav26piql">
          Cosa dicono gli <em className="text-[#1F9D6B]" data-id="element-285" data-mp="31zczs9fbpgbz">insegnanti</em>
        </h2>

        <div className="mt-14 grid gap-10 border-t border-[#1E2B58]/15 pt-10 sm:grid-cols-3" data-id="element-286" data-mp="3228xbwn9e2zw">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-287" data-mp="2s28e0ape3mvp">
              <div className="text-sm text-[#F2B134]" aria-label="5 stelle su 5" data-id="element-288" data-mp="2s42yxp0nvezs">
                <span aria-hidden="true" data-id="element-289" data-mp="v8nbj9lp0ji3">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-[#1E2B58]" data-id="element-290" data-mp="qbn7134hrot3">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-291" data-mp="m51alq9dz37d">
                <span className="font-semibold text-[#1E2B58]" data-id="element-292" data-mp="m6m9fs2qh8b1">{item.name}</span>
                <span className="text-[#1E2B58]/60" data-id="element-293" data-mp="78tt4xpd4fvs"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}